define.alias("shared/utils/hash-code", "media/utils/hash-code");